module.exports = __webpack_public_path__ + "img/system3.cf94f3eb.svg";